import { createSelector } from 'reselect';

export const getParams = (_, params) => params;

/** @returns {import("../reducer").AuditModelReducer} */
const getState = state => state.newAuditModels;

export const getData = createSelector(getState, state => state.data);

export const getUI = createSelector(getState, state => state.ui);

export const getUIDetails = createSelector(getUI, ui => ui.details);

export const getAll = createSelector(getData, data => data.byId);

export const getById = createSelector(
  getAll,
  getParams,
  /** @returns {import('../types').AuditModel | undefined} */
  (collection, id) => collection?.[id]
);

export const isReadyApplication = createSelector(getUIDetails, ui => ui.isReady ?? false);

export const getError = createSelector(getUIDetails, ui => ui.apiError);

export const getSelectedLanguage = createSelector(getUIDetails, details => details.selectedLanguage);

export const getByIds = createSelector(getAll, getParams, (auditModels, ids = []) =>
  ids.map(auditModelId => auditModels[auditModelId]));
